export enum PromptTag {
  PLAYBOOKS = 'playbooks',
  TOOL_DISCOVERY = 'tool-discovery',
}

export const DEFAULT_ACCEPTED_FILE_TYPES = [
  // Images
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  // Documents
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  // Text
  'text/plain',
  'text/csv',
  'text/markdown',
  // Code
  'text/javascript',
  'application/json',
  'text/html',
  'text/css',
  // Archives
  'application/zip',
  'application/x-rar-compressed',
  'application/x-7z-compressed',
]

export const PLAYBOOK_PLACEHOLDERS = [
  {
    title: 'Qualify leads automatically',
    value:
      "Leads are coming in fast through HubSpot, and we need a smarter way to handle them. I'm looking for an AI workflow that can instantly score their intent, qualify them, and assign them to the right rep, so we never miss a high-conversion opportunity again.",
  },
  {
    title: 'Automate email campaigns',
    value:
      "Each week, we push campaigns through Mailchimp, but writing, targeting, and scheduling eats up hours. I'd love an AI system that can generate compelling content, pick the right audience segments, and optimize send times automatically.",
  },
  {
    title: 'Categorize support tickets',
    value:
      'Zendesk gets flooded with tickets, and my team is always playing catch-up. I want an AI-powered flow that can tag and categorize requests, detect sentiment, and flag the ones that need attention right away.',
  },
  {
    title: 'Screen job applications',
    value:
      "Hiring through Greenhouse can feel like a slog when we're swimming in resumes. I'm after a workflow that scans incoming applications, evaluates fit, and sends the best matches to hiring managers without the manual back-and-forth.",
  },
  {
    title: 'Auto-fill invoices',
    value:
      "We're constantly pulling invoice data from emails and entering it into QuickBooks manually. I want an AI process that reads attachments, matches them to purchase orders, and posts everything where it belongs, with zero copy-paste.",
  },
  {
    title: 'Generate content ideas',
    value:
      "Coming up with fresh content ideas in Notion takes longer than it should. I'm looking for an AI assistant that can suggest SEO-relevant topics, structure blog post outlines, and even write solid first drafts to keep publishing on track.",
  },
  {
    title: 'Review contracts',
    value:
      "Before signing any contract in DocuSign, we need to ensure nothing risky slips by. I want AI to scan documents, highlight red flags, and provide a quick risk summary so legal reviews don't bottleneck us.",
  },
  {
    title: 'Triage IT tickets',
    value:
      "Internal IT tickets in Jira are piling up, and triage is eating into my team's time. We need a system that classifies requests, suggests likely fixes, and escalates the complex ones automatically.",
  },
  {
    title: 'Analyze customer feedback',
    value:
      "Intercom feedback is full of gold, but it's buried in chat transcripts. I need an AI-driven process that can cluster user feedback by themes, tie insights to product areas, and feed recommendations into the roadmap.",
  },
  {
    title: 'Update sales forecasts',
    value:
      'Our regional sales numbers live across multiple systems. I want a workflow that pulls live data from Salesforce, updates forecasts in Google Sheets, and highlights pipeline risks before they become problems.',
  },
]

export const TOOL_DISCOVERY_PLACEHOLDERS = [
  {
    title: 'Organize scattered notes',
    value:
      "As a startup founder juggling way too many responsibilities, I'm wondering if Notion AI or Mem.ai is better at helping me keep track of scattered notes, summarize thoughts, and surface ideas I forgot I even wrote down.",
  },
  {
    title: 'Speed up content creation',
    value:
      'Our marketing team is trying to reduce time spent drafting and editing. How do Jasper, Grammarly, and Claude compare when it comes to generating high-quality copy that actually sounds like us?',
  },
  {
    title: 'Build smarter automations',
    value:
      "I've been using traditional automation tools like Zapier, but now I hear Make and n8n have AI modules. As a RevOps lead, should I be switching to one of those if I want smarter and more dynamic automations?",
  },
  {
    title: 'Streamline research process',
    value:
      "We're looking at Perplexity and Arc Browser's AI features to replace our chaotic internal research process. Can you break down how they handle summarizing sources, fact-checking, and staying up to date?",
  },
  {
    title: 'Generate brand-safe images',
    value:
      'My design lead is pushing for Midjourney while the content team swears by Adobe Firefly. I need to understand which AI design tool is better for flexible brand-safe image generation across campaigns.',
  },
  {
    title: 'Turn meetings into action items',
    value:
      "I'm tired of endless meetings that go nowhere. Between Fireflies, OtterPilot, and Wispr Flow, which AI meeting assistant is best at turning discussions into usable summaries and action items?",
  },
  {
    title: 'Prioritize tasks efficiently',
    value:
      'For task prioritization, Reclaim.ai looks promising but Motion and ClickUp AI are also in the mix. As someone who runs a fast-moving product org, I need help figuring out which actually saves time instead of adding noise.',
  },
  {
    title: 'Reach inbox zero',
    value:
      "My inbox is an ever-growing beast. Is it worth investing in Superhuman's AI features or can Gmail plugins like Gmelius and Saner.AI do just as much to help me reach inbox zero?",
  },
  {
    title: 'Track productivity patterns',
    value:
      "I run a small team of freelancers and I need a time tracker that doesn't just track time but helps us understand productivity patterns. How do Clockify, Toggl, and Harvest compare when it comes to AI-powered insights?",
  },
]
